import { getAccountStore } from '@/store/account/actions';
import { getSessionStore } from '@/store/session/actions';
import { useSelector } from 'react-redux';
import { sendEventToGTM } from '@dev/ee-tools';
import { useEffect } from 'react';
import { ProductType } from '@dev/ee-api/ee-api-models';
import { session } from 'store2';

enum LoginMethod {
    EMAIL = 'Email',
    GOOGLE = 'Google Account',
}

export const useGTMLoginEvent = (productType: ProductType) => {
    const { authorized } = useSelector(getSessionStore);
    const account = useSelector(getAccountStore);
    const isLoginSuccess: boolean | null = session.get('loginSuccess');

    const sendLoginEvent = (method: LoginMethod, productType: ProductType) => {
        sendEventToGTM('login', {
            method,
            productType,
        });
    };
    useEffect(() => {
        const isValidLogin = authorized && !account.accountLoading && isLoginSuccess;
        const loginMethod = account.GeneralInfo?.IsGoogleAccount ? LoginMethod.GOOGLE : LoginMethod.EMAIL;
        if (isValidLogin) {
            sendLoginEvent(loginMethod, productType);
            session.remove('loginSuccess');
        }
    }, [authorized, !account.accountLoading, isLoginSuccess]);
};
